module.exports = __webpack_public_path__ + "static/assets/8f53648c1514a11895ff2c933f5753d6.png";